/* eslint-disable */
import Vue from 'vue';
import jQuery from 'jquery';
window.jQuery = jQuery;
import 'bootstrap/dist/js/bootstrap';
import XLSX from 'xlsx'
Vue.prototype.$XLSX = XLSX
import configEnv from '@/config';
Vue.prototype.$AUTHORITY = configEnv.IDENTITY.AUTHORITY;
import App from '@/App';
import router from '@/router';
import store from '@/store';
import config from '@/config/defaultSettings';
import bootstrap from '@/core/bootstrap';

import vueCountryRegionSelect from 'vue-country-region-select'
import CountryFlag from 'vue-country-flag'

Vue.use(vueCountryRegionSelect)
Vue.component('country-flag', CountryFlag)

import Default from '@/layouts/Default';
import Blank from '@/layouts/Blank';
Vue.component('default-layout', Default);
Vue.component('blank-layout', Blank);

import VueErrorException from '@/exceptions/VueErrorException';
import VueWarnException from '@/exceptions/VueWarnException';

require('vue-multiselect/dist/vue-multiselect.min.css');
require('./assets/css/bootstrap.css');
require('./assets/css/header.css');
require('./assets/css/sidebar.css');
require('./assets/css/forms.css');
require('./assets/css/buttons.css');
require('./assets/css/style.css');
require('./assets/css/font-awesome.min.css');
require('./assets/css/bootstrap-select.min.css');

/* eslint-disable no-new */
const app = {
  el: '#app',
  router,
  store,
};

const context = {
  app,
  config,
  Vue,
  router,
};

import plugins from './plugins';
for (let index = 0; index < plugins.length; index++) {
  const plugin = plugins[index];
  if (typeof plugin !== 'function') {
    continue
  }

  try {
    plugin(context);
  } catch (error) {
    console.error('plugin load error: ', error);
  }
}

Vue.config.errorHandler = function (err, vm, info) {
  if (window.appInsights) {
    const $route = vm.$route || {};

    window.appInsights.trackException({
      exception: new VueErrorException(err),
      severityLevel: 3,
      properties: {
        routeName: $route.name,
        routePath: $route.path,
        routeFullPath: $route.fullPath,
        routeQuery: JSON.stringify($route.query || {}),
        routeParams: JSON.stringify($route.params || {})
      },
    });
    window.appInsights.flush();
  } else {
    window.console.error(vm);
    throw err;
  }
}

Vue.config.warnHandler = function (msg, vm, trace) {
  if (window.appInsights) {
    const $route = vm.$route || {};

    window.appInsights.trackException({
      exception: new VueWarnException(msg),
      severityLevel: 2,
      properties: {
        routeName: $route.name,
        routePath: $route.path,
        routeFullPath: $route.fullPath,
        routeQuery: JSON.stringify($route.query || {}),
        routeParams: JSON.stringify($route.params || {})
      },
    });
  } else {
    window.console.warn(msg);
  }
}

new Vue({
  ...app,
  created() {
    bootstrap();
  },
  components: {
    App
  },
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js